export default __webpack_public_path__ + "static/media/decorations-background-top-right.11ece420.svg";